import { useMutation, useQueryClient } from "react-query";
import axios from "../axios";
import { DefaultResponse } from "../../constants/types";

const importItem = async (formData: FormData) => {
    const response = await axios.post<DefaultResponse>(
        "/api/importitem",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
    );
    return response.data;
};

export default function useImportItem() {
    const queryClient = useQueryClient();

    return useMutation((formData: FormData) => importItem(formData), {
        onSuccess: () => {
            queryClient.invalidateQueries(["item"]);
        },
    });
}
